<template>
	<div class="wrapper">
		<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
		    <el-tab-pane label="内容管理" name="first">
				
			</el-tab-pane>
		    <el-tab-pane label="业务管理" name="second">
				
			</el-tab-pane>
			<el-tab-pane label="个人信息" name="four">
				
			</el-tab-pane>
			<el-tab-pane label="申请开博" name="five">
				
			</el-tab-pane>
			<el-tab-pane label="已关注" name="six">
				<woguanzhu :name="activeName" />
			</el-tab-pane>
			<el-tab-pane label="关注我" name="nice">
				<guanzhuwo :name="activeName"></guanzhuwo>
			</el-tab-pane>
			<el-tab-pane label="消息中心" name="ten">
				<noice :name="activeName" :type="Number(typessss)"></noice>
			</el-tab-pane>
		  </el-tabs>
		<div class="wrappers" v-if="activeName=='second'">
			<div class="ct2_a">
				<div class="appl">
					<div class="tbn">
						<div class="mt bbda">业务管理</div>
						<div style="margin: 0;">
							<div class="li" @click="liclioc01(6)" :class="[types==6?'lis':'']">活动报名</div>
							<div class="li" @click="liclioc01(1)" :class="[types==1?'lis':'']">活动需求调查</div>
							<div class="li" @click="liclioc01(2)" :class="[types==2?'lis':'']">环境订单管理</div>
							<div class="li" @click="liclioc01(3)" :class="[types==3?'lis':'']">共享环境加入申请</div>
							<div class="li" @click="liclioc01(4)" :class="[types==4?'lis':'']">运行资源申请</div>
							<div class="li" @click="liclioc01(5)" :class="[types==5?'lis':'']">上线运行申请</div>
							<div class="li" @click="liclioc01(7)" :class="[types==7?'lis':'']">共享环境续费</div>
						</div>
					</div>
				</div>
				
				<div class="mn">
					<el-table
					  v-loading="loading"
					  :data="lists"
					  fit
					  :header-cell-style="{background:'#f5f5f5'}"
					  highlight-current-row
					  style="width: 100%;"
					  v-if="types==1"
					>
					<el-table-column label="活动名称" show-overflow-tooltip align="left">
					  <template slot-scope="scope">
					    <span class="span">{{scope.row.hdtitle}}</span>
					  </template>
					</el-table-column>
					<el-table-column label="活动主题" show-overflow-tooltip align="left">
					  <template slot-scope="scope">
					    <span class="span">{{scope.row.title}}</span>
					  </template>
					</el-table-column>
					<el-table-column label="报名时间" width="180" show-overflow-tooltip align="left">
					  <template slot-scope="scope">
					    <span class="span">{{scope.row.createTime}}</span>
					  </template>
					</el-table-column>
					<el-table-column label="开始时间" show-overflow-tooltip align="left">
					  <template slot-scope="scope">
					    <span class="span">{{scope.row.beginTime}}</span>
					  </template>
					</el-table-column>
					<el-table-column label="结束时间" show-overflow-tooltip align="left">
					  <template slot-scope="scope">
					    <span class="span">{{scope.row.endTime}}</span>
					  </template>
					</el-table-column>
					<el-table-column label="地区" show-overflow-tooltip align="left">
					  <template slot-scope="scope">
					    <span class="span">{{scope.row.address}}</span>
					  </template>
					</el-table-column>
					<el-table-column label="详细地址" show-overflow-tooltip align="left">
					  <template slot-scope="scope">
					    <span class="span">{{scope.row.addressdetail}}</span>
					  </template>
					</el-table-column>
					</el-table>
					
					<el-table
					  v-loading="loading"
					  :data="lists"
					  fit
					  :header-cell-style="{background:'#f5f5f5'}"
					  highlight-current-row
					  style="width: 100%;"
					  v-if="types==2"
					>
					  <el-table-column label="订单信息" show-overflow-tooltip align="left">
					    <template slot-scope="scope">
					      <span class="span">订单号：{{scope.row.orderno}}</span>
					    </template>
					  </el-table-column>
					  <el-table-column label="环境名称" show-overflow-tooltip align="left">
					    <template slot-scope="scope">
					      <span class="span">{{scope.row.title}}</span>
					    </template>
					  </el-table-column>
					  <el-table-column label="栏目" width="120" show-overflow-tooltip align="center">
					    <template slot-scope="scope">
					      <span class="span">{{scope.row.typename}}</span>
					    </template>
					  </el-table-column>
					  <el-table-column label="总价" width="120" show-overflow-tooltip align="center">
					    <template slot-scope="scope">
					      <span class="span" style="color: red;">¥{{scope.row.money}}</span>
					    </template>
					  </el-table-column>
					  <el-table-column label="状态" width="120" show-overflow-tooltip align="center">
					    <template slot-scope="scope">
					    <span class="span">
						  {{scope.row.statusname}}
						</span>
					    </template>
					  </el-table-column>
					  <el-table-column label="操作" width="140" align="center">
					    <template slot-scope="scope">
					      <el-button type="text" size="mini" @click="detailsss(scope.row)">查看详情</el-button>
						  <el-button type="text" size="mini" @click="guanlis(scope.row)" v-if="scope.row.type==3">管理</el-button>
					    </template>
					  </el-table-column>
					</el-table>
					
					<el-table
					  v-loading="loading"
					  :data="lists"
					  fit
					  :header-cell-style="{background:'#f5f5f5'}"
					  highlight-current-row
					  style="width: 100%;"
					  v-if="types==3 || types==4 || types==5 || types==7"
					>
						  <el-table-column label="订单信息" show-overflow-tooltip align="left">
							<template slot-scope="scope">
							  <span class="span">订单号：{{scope.row.orderno}}</span>
							</template>
						  </el-table-column>
						  <el-table-column label="类型" show-overflow-tooltip align="left" v-if="types!=7">
						    <template slot-scope="scope">
						      <span class="span" v-if="types==3">{{scope.row.type==1?'个人':'组织'}}</span>
							  <span class="span" v-if="types==4 || types==5">{{scope.row.types==1?'个人':'组织'}}</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="环境名称" show-overflow-tooltip align="left">
						    <template slot-scope="scope">
						      <span class="span">{{scope.row.huanjingname}}</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="用户ID" show-overflow-tooltip align="left" v-if="types==7">
						    <template slot-scope="scope">
						      <span class="span">{{scope.row.userarr}}</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="总价" width="120" show-overflow-tooltip align="center">
						    <template slot-scope="scope">
						      <span class="span" style="color: red;">¥{{scope.row.money}}</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="状态" width="120" show-overflow-tooltip align="center">
						    <template slot-scope="scope">
						    <span class="span">
							  {{scope.row.statusname}}
							</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="操作" width="140" align="center">
						    <template slot-scope="scope">
						      <el-button type="text" size="mini" @click="xiangiqngs(scope.row)">查看详情</el-button>
						    </template>
						  </el-table-column>
					</el-table>
					
					<el-table
					  v-loading="loading"
					  :data="lists"
					  fit
					  :header-cell-style="{background:'#f5f5f5'}"
					  highlight-current-row
					  style="width: 100%;"
					  v-if="types==6"
					>
						  <el-table-column label="订单信息" show-overflow-tooltip align="left">
							<template slot-scope="scope">
							  <span class="span">订单号：{{scope.row.orderno}}</span>
							</template>
						  </el-table-column>
						  <el-table-column label="类型" show-overflow-tooltip align="left">
						    <template slot-scope="scope">
							  <span class="span">{{scope.row.type==1?'个人':'组织'}}</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="活动名称" show-overflow-tooltip align="left">
						    <template slot-scope="scope">
						      <span class="span">{{scope.row.hdname}}</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="总价" width="120" show-overflow-tooltip align="center">
						    <template slot-scope="scope">
						      <span class="span" style="color: red;">¥{{scope.row.money}}</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="状态" width="120" show-overflow-tooltip align="center">
						    <template slot-scope="scope">
						    <span class="span">
							  {{scope.row.statusname}}
							</span>
						    </template>
						  </el-table-column>
						  <el-table-column label="操作" width="140" align="center">
						    <template slot-scope="scope">
						      <el-button type="text" size="mini" @click="baomings(scope.row)">查看详情</el-button>
						    </template>
						  </el-table-column>
					</el-table>
					
					<!-- 分页 -->
					<div class="pagination-container" style="margin-top: 20px;">
					  <el-pagination
					    :current-page="query.page"
					    :page-sizes="[10,20,30, 40]"
					    :page-size="query.limit"
					    :total="totals"
					    background layout="total, sizes, prev, pager, next, jumper"
					    @size-change="handleSizeChanges"
					    @current-change="handleCurrentChanges"
					  />
					</div>
				</div>
			</div>
		</div>
		<div class="wrappers" v-if="activeName=='first'">
			<div class="ct2_a">
				<div class="appl">
					<div class="tbn">
						<div class="mt bbda">内容管理</div>
						<div style="margin: 0;">
							<div class="li" @click="liclioc(1)" :class="[type==1?'lis':'']">博客管理</div>
							<div class="li" @click="liclioc(2)" :class="[type==2?'lis':'']">帖子管理</div>
						</div>
					</div>
				</div>
				
				<div class="mn">
					<div style="margin-bottom: 10px;">
						<el-button type="primary" size="small" @click="handlecreate(1)">{{type==1?'发布博客':'发布新帖'}}</el-button>
					</div>
					<el-table
					  v-loading="loading"
					  :data="list"
					  fit
					  :header-cell-style="{background:'#f5f5f5'}"
					  highlight-current-row
					  style="width: 100%;"
					>
					  <el-table-column label="标题" show-overflow-tooltip align="left">
					    <template slot-scope="scope">
					      <span class="span" @click="detail(scope.row.id)">{{scope.row.title}}</span>
					    </template>
					  </el-table-column>
					  <el-table-column label="发布日期" width="180" show-overflow-tooltip align="left">
					    <template slot-scope="scope">
					      <span>{{scope.row.createTime}}</span>
					    </template>
					  </el-table-column>
					  <el-table-column label="操作" width="120" align="left">
					    <template slot-scope="scope">
					      <el-button type="text" size="mini" @click="handlecreate(2,scope.row)">编辑</el-button>
						  <el-button type="text" size="mini" @click="dels(scope.row.id)">
							  <span style="color: red;">
								  删除
							  </span>
						  </el-button>
					    </template>
					  </el-table-column>
					</el-table>
					
					<!-- 分页 -->
					<div class="pagination-container" style="margin-top: 20px;">
					  <el-pagination
					    :current-page="listQuery.page"
					    :page-sizes="[10,20,30, 40]"
					    :page-size="listQuery.limit"
					    :total="total"
					    background layout="total, sizes, prev, pager, next, jumper"
					    @size-change="handleSizeChange"
					    @current-change="handleCurrentChange"
					  />
					</div>
				</div>
			</div>
		</div>
		<bokesave ref="bokesavedata" @succ="succcreate"></bokesave>
		<tiezisave ref="tiezisavedata" @succ="succcreates"></tiezisave>
		
		<!--订单详情-->
		<detail ref="detaildata" @siucc="user_huanjing_orderlist()" />
		
		<!--共享订单加入详情-->
		<shenqingdetail ref="shenqingdetaildata" @sizzsa="user_gongxiang_look"></shenqingdetail>
		<!--共享订单加入详情-->
		
		<!--用户续费详情-->
		<xufeidetail ref="xufeidetaildata" @chenggong="user_gxxufei_list()"></xufeidetail>
		<!--用户续费详情-->
		
		<!--运行资源申请订单-->
		<yunxingdetail ref="yunxingdetaildata" @chenggong="user_yunxing_list"></yunxingdetail>
		<!--运行资源申请订单-->
		<!--活动报名订单-->
		<huodongdetail ref="huodongdetaildata" @huodongsucc="user_hdbaoming_list"></huodongdetail>
		<!--活动报名订单-->
		<!--共享环境加入管理-->
		<gongadmin ref="gongadmindata" @falses="user_huanjing_orderlist"></gongadmin>
		<!--共享环境加入管理-->
		
		<!--个人信息-->
		<div class="wrappers" v-if="activeName=='four'">
			<user />
		</div>
		<!--个人信息-->
		
		<!--申请开博-->
		<div class="wrappers" v-if="activeName=='five'">
			<kaibo />
		</div>
		<!--申请开博-->
	</div>
</template>

<script>
	import { boke_new_list,tiezi_new_list,zhuanti_list,user_boke_delete,user_tiezi_delete } from "@/api/boke"
	import { user_baoming_list } from "@/api/news"
	import bokesave from "@/views/luntan/boke/components/save.vue"
	import tiezisave from "@/views/luntan/luntan/components/save.vue"
	import { getToken } from '@/utils/auth'
	import { user_huanjing_orderlist,user_gongxiang_look,user_yunxing_list,user_hdbaoming_list,user_gxxufei_list } from "@/api/huanjing"
	import gongadmin from "./components/gongadmin.vue"
	import detail from "./detail.vue"
	import shenqingdetail from "./components/shenqingdetail"
	import yunxingdetail from "./components/yunxingdetail.vue"
	import huodongdetail from "./components/huodongdetail.vue"
	import xufeidetail from "./components/xufeidetail.vue"
	import user from "./new/user.vue"
	import kaibo from "./new/kaibo.vue"
	import woguanzhu from "./new/woguanzhu.vue"
	import guanzhuwo from "./new/guanzhuwo.vue"
	import noice from "./new/noice.vue"
	export default {
		components:{
			bokesave,tiezisave,detail,gongadmin,shenqingdetail,yunxingdetail,
			huodongdetail,user,kaibo,xufeidetail,woguanzhu,guanzhuwo,noice
		},
		data(){
			return{
				type:1,//1博客管理 2论坛管理
				
				listQuery:{
					page:1,
					limit:10
				},
				total:0,
				list:[],
				loading:false,
				
				activeName:'first',
				types:1,
				query:{
					page:1,
					limit:10
				},
				totals:0,
				lists:[],//活动报名列表
				
				neirongtype:100,//1共享环境加入申请 2运行资源申请 3上线运行申请
				
				typessss:1,
			}
		},
		mounted(){
			if(this.$route.query.activeName){
				this.activeName = this.$route.query.activeName
				this.typessss = this.$route.query.type
				return;
			}
			this.neirongtype = this.$route.query.neirongtype?this.$route.query.neirongtype:100
			if(this.$route.query.orderid && this.neirongtype==100){
				//环境订单管理
				document.title = "业务管理-环境订单管理"
				this.activeName ='second'
				this.types = 2
				this.$refs.detaildata.handlecreate(this.$route.query.orderid);
			}else if(this.$route.query.orderid && this.neirongtype==1){
				//共享环境加入申请
				document.title = "业务管理-共享环境加入申请"
				this.activeName ='second'
				this.types = 3
				this.$refs.shenqingdetaildata.handlecreate(this.$route.query.orderid);
			}else if(this.$route.query.orderid && this.neirongtype==2){
				//运行资源申请
				document.title = "业务管理-运行资源申请"
				this.activeName ='second'
				this.types = 4
				this.$refs.yunxingdetaildata.handlecreate(this.$route.query.orderid);
			}else if(this.$route.query.orderid && this.neirongtype==3){
				//运行资源申请
				document.title = "业务管理-上线运行申请"
				this.activeName ='second'
				this.types = 5
				this.$refs.yunxingdetaildata.handlecreate(this.$route.query.orderid);
			}else if(this.$route.query.orderid && this.neirongtype==4){
				//活动报名
				document.title = "业务管理-活动报名"
				this.activeName ='second'
				this.types = 6
				this.$refs.huodongdetaildata.handlecreate(this.$route.query.orderid);
			}else if(this.$route.query.orderid && this.neirongtype==5){
				//共享环境续费
				document.title = "业务管理-共享环境续费"
				this.activeName ='second'
				this.types = 7
				this.$refs.xufeidetaildata.handlecreate(this.$route.query.orderid);
			}else{
				document.title = "内容管理"
				this.boke_new_list();
			}
			
		},
		methods:{
			guanlis(row){
				this.$refs.gongadmindata.show(row)
			},
			baomings(row){
				this.$refs.huodongdetaildata.handlecreate(row.id)
			},
			detailsss(row){
				console.log(row);
				this.$refs.detaildata.handlecreate(row.id);
			},
			xiangiqngs(row){
				console.log("查看详情",row);
				if(this.types==3){
					this.$refs.shenqingdetaildata.handlecreate(row.id);
				}
				if(this.types==4 || this.types==5){
					this.$refs.yunxingdetaildata.handlecreate(row.id);
				}
				if(this.types==7){
					this.$refs.xufeidetaildata.handlecreate(row.id)
				}
			},
			handleClick(e){
				console.log("e",e);
				//如果点击了业务管理
				if(e.index==1){
					this.types = 1
					this.query.page = 1
					this.user_baoming_list();//报名列表
				}
			},
			user_baoming_list(){
				this.loading = true
				user_baoming_list(this.query).then(res=>{
					this.loading = false
					console.log("活动需求调查列表",res.data);
					this.totals = res.data.total
					this.lists = res.data.list
				}).catch(()=>{
					this.loading = false
				})
			},
			user_huanjing_orderlist(){
				this.loading = true
				user_huanjing_orderlist(this.query).then(res=>{
					this.loading = false
					console.log("订单管理",res.data);
					this.totals = res.data.total
					this.lists = res.data.list
					this.loading = false
				}).catch(()=>{
					this.loading = false
				})
			},
			user_gongxiang_look(){
				this.loading = true
				user_gongxiang_look(this.query).then(res=>{
					this.loading = false
					console.log("环境加入申请",res.data);
					this.totals = res.data.total
					this.lists = res.data.list
					this.loading = false
				}).catch(()=>{
					this.loading = false
				})
			},
			user_yunxing_list(){
				this.loading = true
				let a = {
					page:this.query.page,
					limit:this.query.limit,
					yunxingtype:this.types==4?1:2
				};
				user_yunxing_list(a).then(res=>{
					this.loading = false
					console.log("运行资源申请",res.data);
					this.totals = res.data.total
					this.lists = res.data.list
					this.loading = false
				}).catch(()=>{
					this.loading = false
				})
			},
			user_hdbaoming_list(){
				this.loading = true
				let a = {
					page:this.query.page,
					limit:this.query.limit,
					yunxingtype:this.types==4?1:2
				};
				user_hdbaoming_list(a).then(res=>{
					this.loading = false
					console.log("活动报名列表",res.data);
					this.totals = res.data.total
					this.lists = res.data.list
					this.loading = false
				}).catch(()=>{
					this.loading = false
				})
			},
			user_gxxufei_list(){
				this.loading = true
				let a = {
					page:this.query.page,
					limit:this.query.limit,
				};
				user_gxxufei_list(a).then(res=>{
					this.loading = false
					console.log("用户续费列表",res.data);
					this.totals = res.data.total
					this.lists = res.data.list
					this.loading = false
				}).catch(()=>{
					this.loading = false
				})
			},
			detail(id){
				if(this.type==1){
					this.$router.push({
						path:"/bokedetail",
						query:{
							id:id
						}
					})
				}
				if(this.type==2){
					this.$router.push({
						path:"/forumdetail",
						query:{
							id:id
						}
					})
				}
			},
			dels(id){
				if(this.type==1){
					this.$confirm('确认删除此条博客吗?', '提示', {
						  confirmButtonText: '确定',
						  cancelButtonText: '取消',
						  type: 'warning'
						}).then(()=>{
							const loading = this.$loading({
							    lock: true,
							    text: '删除中',
							    spinner: 'el-icon-loading',
							    background: 'rgba(0, 0, 0, 0.7)'
							  });
							  user_boke_delete({id:id}).then(()=>{
								  loading.close();
								  this.$message.success("删除成功");
								  this.boke_new_list();
							  }).catch(()=>{
								  loading.close();
							  })
						})
				}
				if(this.type==2){
					this.$confirm('确认删除此条帖子吗?', '提示', {
						  confirmButtonText: '确定',
						  cancelButtonText: '取消',
						  type: 'warning'
						}).then(()=>{
							const loading = this.$loading({
							    lock: true,
							    text: '删除中',
							    spinner: 'el-icon-loading',
							    background: 'rgba(0, 0, 0, 0.7)'
							  });
							  user_tiezi_delete({id:id}).then(()=>{
								  loading.close();
								  this.$message.success("删除成功");
								  this.boke_new_list();
							  }).catch(()=>{
								  loading.close();
							  })
						})
					
				}
			},
			handlecreate(type,item){
				if(this.type==1){
					if(getToken()){
						this.$refs.bokesavedata.handlecreate(type,item);
					}else{
						loginEvent.$emit('loginDialogEvent')
					}
				}
				if(this.type==2){
					if(getToken()){
						this.$refs.tiezisavedata.handlecreate(type,item);
					}else{
						loginEvent.$emit('loginDialogEvent')
					}
				}
			},
			succcreate(){
				this.boke_new_list();
			},
			succcreates(){
				this.tiezi_new_list();
			},
			boke_new_list(){
				this.loading = true
				this.list = [];;
				boke_new_list(this.listQuery).then(res=>{
					this.loading = false
					console.log("博客列表",res.data);
					this.total = res.data.total
					this.list = res.data.list
				}).catch(()=>{
					this.loading = false
				})
			},
			tiezi_new_list(){
				this.loading = true
				this.list = [];;
				tiezi_new_list(this.listQuery).then(res=>{
					this.loading = false
					console.log("帖子列表",res.data);
					this.total = res.data.total
					this.list = res.data.list
				}).catch(()=>{
					this.loading = false
				})
			},
			//下一页上一页操作
			handleSizeChange(val) {//条数
			  this.listQuery.limit = val
			  if(this.type==1){
				  this.boke_new_list();
			  }else{
				  this.tiezi_new_list();
			  }
			  
			},
			handleCurrentChange(val) {//列数
			  this.listQuery.page = val
			 if(this.type==1){
			   this.boke_new_list();
			 }else{
			   this.tiezi_new_list();
			 }
			},
			handleSizeChanges(val){
				this.query.limit = 1
				if(this.types==1){
					this.user_baoming_list();
				}else{
					//订单管理
					this.user_huanjing_orderlist();
				}
			},
			handleCurrentChanges(val){
				this.query.page = 1
				if(this.types==1){
					this.user_baoming_list();
				}else{
					//订单管理
					this.user_huanjing_orderlist();
				}
			},
			liclioc(type){
				this.type = type
				this.listQuery.page = 1
				if(this.type==1){
				  this.boke_new_list();
				}else{
				  this.tiezi_new_list();
				}
			},
			liclioc01(type){
				this.types = type
				this.query.page = 1
				//活动需求调查
				if(this.types==1){
				  this.user_baoming_list()
				}else if(this.types==2){
					//订单管理
				    this.user_huanjing_orderlist();
				}else if(this.types==3){
					//共享环境加入申请
					this.user_gongxiang_look();
				}else if(this.types==4 || this.types==5){
					//运行资源申请
					this.user_yunxing_list();
				}else if(this.types==6){
					//活动报名
					this.user_hdbaoming_list();
				}else if(this.types==7){
					//共享环境续费
					this.user_gxxufei_list();
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.mn{
		display: inline;
		    float: right;
		    width: 1010px;
		    margin-right: 25px;
		    padding-top: 20px;
	}
	.span{
		cursor: pointer;
	}
	.span:hover{
		color: #FFA07A;
	}
	.mt{
		padding: 10px;
		font-size: 16px;
	}
	.ct2_a{
		width: 100%;
		border: 1px solid #f0f0f0;
		background: #fff url("../../../assets/vlineb.png") repeat-y 0 0;
		width: auto;
		min-height: 750px;
		.appl{
			float: left;
			    overflow: hidden;
			    margin-bottom: 10px;
			    padding: 6px 10px;
			    width: 117px;
			.tbn{
				margin: -6px -10px 0;
				.li{
					width: 100%;
					height: 40px;
					line-height: 40px;
					border-bottom: 1px dashed #CCC;
					font-size: 14px;
					margin: 0 10px;
					color: #333;
					cursor: pointer;
				}
				.lis{
					    margin: -1px 0 0;
					    padding: 0 10px 0 9px;
					    border-top: 1px solid #f0f0f0;
					    border-bottom-style: solid;
					    background: #FFF;
				}
				.li:hover{
					color: #FFA07A;
				}
				.bbda{
					border-bottom: 1px dashed #f0f0f0;
					font-weight: bold;
				}
			}
		}
	}
	.wrapper{
		width: 1200px;
		margin: 0 auto;
		padding-top: 30px;
		.wrappers{
			width: 100%;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/luntan/neirong/index.vue